import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { store } from './store';

import 'remixicon/fonts/remixicon.css';
import '@/common/css/reset.css';
import '@/common/css/variables.css';

// import firebase from 'firebase';
// import firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/firestore';
// import 'firebase/analytics';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getAnalytics } from 'firebase/analytics';
// self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
// import 'firebase/app-check';

const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(config);
const analytics = getAnalytics();
// const appCheck = firebase.appCheck();
// appCheck.activate('6Lc3q9saAAAAADmnvZkxPqcmj7ZGTfLS5J0hGE_S');
// firebase.analytics();
export const db = firebase.firestore();
export const serverTimestamp = () =>
  firebase.firestore.FieldValue.serverTimestamp();
export const arrayUnion = (arg: any) =>
  firebase.firestore.FieldValue.arrayUnion(arg);
export const arrayRemove = (arg: any) =>
  firebase.firestore.FieldValue.arrayRemove(arg);
export const fieldDelete = () => firebase.firestore.FieldValue.delete();

createApp(App)
  .use(router)
  .use(store)
  .mount('#app');
